import { CloudCommand } from "../types.js";

export const getCompany: CloudCommand = {
    action: "USER_INFOS/GET_COMPANY",
    commandName: "linkedin.user.getCompany",
    buildPayload: () => ({}),
};
